<template>
	<loader v-if="!store.loaded" :text="loadingModelsMessage"/>
	<div v-else class="v-table">
		<VTableFilters :filters="store.filters" :showDownload="showDownload"/>
		<div v-if="!hasItems" class="section--empty">
			<loader v-if="store.gettingModels"/>
			<slot v-else name="empty">
				<p v-if="noModelsMessage" v-html="noModelsMessage"/>
			</slot>
		</div>
		<table v-else :class="tableClass" role="grid">
			<loader v-if="store.gettingModels"/>
			<thead>
				<tr>
					<th
						v-for="(column, columnIndex) in store.columns" :key="columnIndex" :align="column.alignment"
						:data-name="column.property" :data-priority="column.priority">
						<div v-html="column.label"/>
					</th>
					<th v-if="showActionsColumn" align="right" class="actions">
						<span>Actions</span>
					</th>
				</tr>
			</thead>
			<tfoot>
				<tr>
					<th
						v-for="(column, columnIndex) in store.columns" :key="columnIndex" :align="column.alignment"
						:data-name="column.property" :data-priority="column.priority">
						<div v-html="column.label"/>
					</th>
					<th v-if="showActionsColumn" align="right" class="actions">
						<span>Actions</span>
					</th>
				</tr>
			</tfoot>
			<tbody>
				<tr v-for="(data, dataIndex) in store.items" :key="dataIndex">
					<td
						v-for="(column, columnIndex) in store.columns" :key="columnIndex" :align="column.alignment"
						:class="getColumnClass(column)" :data-name="column.property" :data-priority="column.priority">
						<span v-if="!getDataProperty(data, column)">—</span>
						<template v-else>
							<StatusBadge
								v-if="'status' === column.display" :group="column.meta?.statusGroup"
								:status="getDataProperty(data, column)"/>
							<div
								v-else-if="'price' === column.display"
								v-html="$present('price', getDataProperty(data, column))"/>
							<bool-icon v-else-if="'boolean' === column.display" :value="getDataProperty(data, column)"/>
							<div v-else>
								<AppLink
									v-if="isLink(column)" :to="triggerLink(data, column)"
									v-html="getDataProperty(data, column, true)"/>
								<span v-else v-html="getDataProperty(data, column, true)"/>
							</div>
						</template>
					</td>
					<td v-if="showActionsColumn" align="right">
						<slot :item="data" name="actions"/>
					</td>
				</tr>
			</tbody>
		</table>
		<paginator :go-to-page="goToPage" :links="store.links" :meta="store.meta"/>
	</div>
</template>
<script>
import VTableFilters from "@/common/components/v-table/v-table-filters.vue";
import StatusBadge from "@/components/StatusBadge.vue";
import interactsWithStore from "@/mixins/interactsWithStore";

export default {
	mixins: [interactsWithStore],

	components: {
		VTableFilters,
		StatusBadge,
	},

	computed: {
		tableClass() {
			return {
				loading: this.store.gettingModels,
			};
		},
		hasItems() {
			return Object.keys(this.store.items).length > 0;
		},
		sortedItems() {
			return this.store.sortedItems;
		},
		showActionsColumn() {
			return this.$scopedSlots.actions;
		},
	},
	props: {
		loadingModelsMessage: {
			required: false,
			type: String,
			default() {
				return null;
			},
		},
		noModelsMessage: {
			required: false,
			type: String,
			default() {
				return "Nothing to display";
			},
		},
		links: {
			type: Object,
			default() {
				return {};
			},
		},
		showDownload: {
			required: false,
			type: Boolean,
			default() {
				return false;
			},
		},
	},
	methods: {
		clearFilter(key) {
			this.dispatch("clearFilter", key);
		},
		filter(query) {
			this.dispatch("filter", query);
		},
		getColumnClass(column) {
			return {
				"truncate": column.truncate === true,
			};
		},
		getDataProperty(data, column, present = false) {
			if (column.property === "") {
				return data;
			}

			let value = _.get(data, column.property, null);

			if (value === null) {
				return value;
			}

			return column.display && present ? this.$present(column.display, value) : value;
		},
		goToPage(page) {
			return this.dispatch("goToPage", page);
		},
		isLink(column) {
			return _.has(this.links, column.property);
		},
		paginate(perPage) {
			return this.dispatch("paginate", perPage);
		},
		triggerLink(data, column) {
			return this.links[column.property](data, column);
		},
	},

	mounted() {
		this.filter(this.$route.query);
	},

	destroyed() {
		return this.dispatch("reset");
	},
};
</script>
